import { Project } from "./ProjectInterface";
import { SharedFolder } from "./SharedFolder";

export interface AllProjectAndSharedType {
  folderData?: SharedFolder | null;
  projectData?: Project | null;
  category: "Shared Folder" | "My Project";
}
// to single object maping
export const mapAllProjectAndSharedType = (
  data: any,
): AllProjectAndSharedType => {
  if (!data) {
    throw new Error("Invalid Data");
  }
  const res: AllProjectAndSharedType = {
    folderData: data.folderData !== null ? data.folderData : null,
    category: data.category,
    projectData: data.projectData !== null ? data.projectData : null,
  };
  return res;
};

// maping list objects
export const mapAllProjectAndSharedTypes = (
  data: any[],
): AllProjectAndSharedType[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }
  return data.map(mapAllProjectAndSharedType);
};
